/**
 * Utility function to determine if anytime prices should be hidden on search.
 *
 * Prices are hidden when:
 * - The search is an "anytime" search (no specific dates or flexible dates selected)
 * - AND the user is NOT coming from a specific UTM source
 *
 * @param isAnytimeSearch - Whether the current search has no specific dates
 * @param utmBp - The UTM bp parameter value
 * @returns Whether to hide anytime prices
 */
export function shouldHideAnytimePrices(
  isAnytimeSearch: boolean,
  utmBp: string | undefined,
): boolean {
  return !utmBp && isAnytimeSearch
}
